import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import messages from '../../../onboard/steps/marketplace-step/messages';

export const CONNECTED_MARKETPLACES_GUIDS = 'Connected-Marketplaces-GUIDs';
export const NotificationTitle = <FormattedMessage {...messages.saveSuccessTitle} />;
export const MobileContent = () => <FormattedMessage {...messages.mobileConnectionSuccess} />;
export const DesktopContent = (
  <FormattedMessage
    {...messages.saveSuccessMessage}
    values={{
      a: (chunks) => <Link to='/orders/awaiting-shipment'>{chunks}</Link>,
    }}
  />
);
